
import React from 'react'
import '../scss/MsgNetLoading.css'

const MsgNetLoading = () => (
  <div className='loading'>
    <div className='loading__background' />
    <img src='/img/eclipse.apng' className='loading__img' alt='Cargando..' />
  </div>
)

export default MsgNetLoading



// WEBPACK FOOTER //
// ./src/components/MsgNetLoading.js